export default [
  {
    path: '/main/passGroupManage',
    name: 'passGroupManage',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/passGroupManage')
  },
  {
    path: '/main/passGroupManageProject',
    name: 'passGroupManageProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/passGroupManageProject')
  },
  {
    path: '/main/accessManage',
    name: 'accessManage',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/accessManage')
  },
  {
    path: '/main/accessManageProject',
    name: 'accessManageProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/accessManageProject')
  },
  {
    path: '/main/deviceTypeManage',
    name: 'deviceTypeManage',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/deviceTypeManage')
  },
  {
    path: '/main/deviceManage',
    name: 'deviceManage',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/deviceManage')
  },
  {
    path: '/main/deviceManageProject',
    name: 'deviceManageProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/deviceManageProject')
  },
  {
    path: '/main/equipmentMaintenance',
    name: 'equipmentMaintenance',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/equipmentMaintenanceM')
  },
  {
    path: '/main/equipmentMaintenanceProject',
    name: 'equipmentMaintenanceProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/equipmentMaintenance')
  },
  {
    path: '/main/passDeviceManageProject',
    name: 'passDeviceManageProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/passDeviceManageProject')
  },
  {
    path: '/main/deviceStatusMonitoring',
    name: 'deviceStatusMonitoring',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/deviceStatusMonitoring')
  },
  {
    path: '/main/cardManage',
    name: 'cardManage',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/cardManage')
  },
  {
    path: '/main/cardManageProject',
    name: 'cardManageProject',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: 'passManage' */ '../pages/passManage/cardManageProject')
  }, {
    path: '/main/cloudAudit',
    name: 'cloudAudit',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/passManage/cloudAudit/cloudAudit.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/passManage.js